module.exports = __webpack_public_path__ + "img/cc.12b2a484.svg";